"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var sc = _interopRequireWildcard(require("./Select.styles"));

var Select = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var renderPlaceholder = function renderPlaceholder() {
    var placeholder = props.placeholder;
    if (!placeholder) return null;
    return /*#__PURE__*/_react["default"].createElement("option", {
      disabled: true,
      value: "",
      key: "placeholder"
    }, placeholder);
  };

  var a11yText = props.a11yText,
      className = props.className,
      children = props.children,
      hasError = props.hasError,
      isDisabled = props.isDisabled,
      isReadOnly = props.isReadOnly,
      size = props.size,
      placeholder = props.placeholder,
      value = props.value,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "className", "children", "hasError", "isDisabled", "isReadOnly", "size", "placeholder", "value"]);

  if (a11yText || placeholder) {
    moreProps["aria-label"] = a11yText || placeholder;
  }

  var rootClasses = (0, _classnames["default"])("form-select", "form-select--".concat(size), {
    "form-select--placeholder": !value && placeholder
  }, {
    "form-select--is-disabled": isDisabled
  }, {
    "form-select--is-readonly": isReadOnly
  }, {
    "form-select--has-error": hasError
  }, className);
  return /*#__PURE__*/_react["default"].createElement(sc.Select, {
    className: rootClasses,
    "data-pka-anchor": "select"
  }, /*#__PURE__*/_react["default"].createElement("select", (0, _extends2["default"])({
    "aria-invalid": hasError,
    className: "form-select__select",
    disabled: isDisabled || isReadOnly,
    ref: ref,
    value: value
  }, moreProps), renderPlaceholder(), children));
});

Select.types = {
  size: constants.defaultSize
};
var propTypes = {
  a11yText: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  hasError: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isReadOnly: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  size: _propTypes["default"].oneOf([Select.types.size.SMALL, Select.types.size.MEDIUM, Select.types.size.LARGE]),
  value: _propTypes["default"].string
};
var defaultProps = {
  a11yText: null,
  className: null,
  children: null,
  hasError: false,
  isDisabled: false,
  isReadOnly: false,
  placeholder: null,
  size: Select.types.size.MEDIUM,
  value: ""
};
Select.displayName = "Select";
Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
var _default = Select;
exports["default"] = _default;
//# sourceMappingURL=Select.js.map